const List = () => import(/* webpackChunkName: "exclusao-cartao-intercambio" */ './main.vue');

export default [
  {
    name: 'exclusao-cartao-intercambio',
    path: '/exclusao-cartao-intercambio',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Exclusão Cartões Intercâmbio',
      icon: 'minus-circle',
      can: 'removecartoes',
      on: 'procint',
      bisneto: true,
      client: 'copass',
    },
  },
];
